import { createAsyncThunk } from "@reduxjs/toolkit";
import APILIST from "../../../Config/ApiList";
import AxiosInstance from "../../../Config/AxiosInstance";

export const GET_ANALYTICS_ACTION = createAsyncThunk('/analytics', async (user_id) => {
    try {
      const response = await AxiosInstance.get(APILIST.GET_ANALYTICS, {
        params: {
            user_id: user_id,
        }
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  })